import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { ContactFormModal } from './ContactFormModal';

export const Pricing = () => {
  const [activeModal, setActiveModal] = useState(null);

  const plans = [
    {
      name: 'Basic',
      price: '59',
      period: 'Monat',
      features: [
        'Zugang zum 12-Wochen-Programm',
        'Alle Video-Lektionen',
        'Selbstständiges Training'
      ],
      buttonText: 'Basic buchen',
      popular: false,
      serviceType: 'basic_plan'
    },
    {
      name: 'Pro',
      price: '129',
      period: 'Monat',
      features: [
        'Alles aus Basic',
        'Individuelle Videoanalyse',
        'Chat-Support',
        'Wöchentliche Check-ins',
        'Anpassungen bei Bedarf'
      ],
      buttonText: 'Pro buchen',
      popular: true,
      serviceType: 'pro_plan'
    },
    {
      name: 'Premium',
      price: '299',
      period: 'Monat',
      features: [
        'Alles aus Pro',
        'Persönliche Online-Beratung',
        'Maßgeschneiderter Trainingsplan',
        'Prioritäts-Support',
        'Direkter Zugang zu Alex'
      ],
      buttonText: 'Premium buchen',
      popular: false,
      serviceType: 'premium_plan'
    }
  ];

  return (
    <section id="tarife" style={{
      padding: 'var(--spacing-giant) 0'
    }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="display-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Wähle deinen Tarif
          </h2>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Flexibel, transparent und auf deine Bedürfnisse zugeschnitten.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: 'var(--spacing-large)',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          {plans.map((plan, index) => (
            <div key={index} className="network-card" style={{
              position: 'relative',
              cursor: 'default',
              border: plan.popular ? '3px solid var(--brand-primary)' : 'none',
              transform: plan.popular ? 'scale(1.05)' : 'scale(1)'
            }}>
              {plan.popular && (
                <div style={{
                  position: 'absolute',
                  top: '-12px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: 'var(--brand-primary)',
                  color: 'var(--brand-dark)',
                  padding: '6px 20px',
                  borderRadius: '20px',
                  fontSize: '0.875rem',
                  fontWeight: 600
                }}>
                  Beliebteste Wahl
                </div>
              )}

              <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-large)' }}>
                <h3 className="heading-2" style={{ marginBottom: 'var(--spacing-small)' }}>
                  {plan.name}
                </h3>
                <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'center', gap: '8px' }}>
                  <span style={{ fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', fontWeight: 700, color: 'var(--brand-dark)' }}>
                    {plan.price}€
                  </span>
                  <span className="body-medium" style={{ color: 'var(--text-light)' }}>/ {plan.period}</span>
                </div>
              </div>

              <div style={{ marginBottom: 'var(--spacing-large)' }}>
                {plan.features.map((feature, idx) => (
                  <div key={idx} style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 'var(--spacing-small)',
                    marginBottom: 'var(--spacing-small)'
                  }}>
                    <Check size={20} style={{ color: 'var(--brand-dark)', flexShrink: 0, marginTop: '2px' }} />
                    <span className="body-medium">{feature}</span>
                  </div>
                ))}
              </div>

              <button 
                onClick={() => setActiveModal(plan.serviceType)}
                className="btn-primary" 
                style={{ width: '100%', justifyContent: 'center' }}
                data-testid={`buy-${plan.serviceType}-button`}
              >
                {plan.buttonText}
              </button>
              <p style={{ fontSize: '0.75rem', color: 'var(--text-light)', textAlign: 'center', marginTop: 'var(--spacing-small)' }}>
                Mit dem Kauf akzeptieren Sie die AGB und Widerrufsbelehrung.
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Form Modals */}
      <ContactFormModal
        isOpen={activeModal === 'basic_plan'}
        onClose={() => setActiveModal(null)}
        serviceType="basic_plan"
        title="Basic Plan buchen"
        description="Füllen Sie das Formular aus, um fortzufahren. Sie werden dann zur Zahlung weitergeleitet."
      />
      <ContactFormModal
        isOpen={activeModal === 'pro_plan'}
        onClose={() => setActiveModal(null)}
        serviceType="pro_plan"
        title="Pro Plan buchen"
        description="Füllen Sie das Formular aus, um fortzufahren. Sie werden dann zur Zahlung weitergeleitet."
      />
      <ContactFormModal
        isOpen={activeModal === 'premium_plan'}
        onClose={() => setActiveModal(null)}
        serviceType="premium_plan"
        title="Premium Plan buchen"
        description="Füllen Sie das Formular aus, um fortzufahren. Sie werden dann zur Zahlung weitergeleitet."
      />
    </section>
  );
};
